<template>
    <div class="upload-file-status" :class="downStatus ? 'isDown' : 'notDown'">
        <div class="upload-btn-group">
            <i
                :class="downStatus ? 'fa fa-angle-double-up' : 'fa fa-angle-double-down'"
                class="upload-arrow"
                @click="downUpload"
            ></i>
            <i class="upload-close fa fa-close" @click="closeUpload"></i>
        </div>
        <el-table :data="tableData" style="width: 100%;" height="250">
            <el-table-column type="index" width="50"> </el-table-column>
            <el-table-column prop="fileName" label="文件名" width="200"> </el-table-column>
            <el-table-column label="上传进度" width="100">
                <template slot-scope="scope">
                    <el-progress type="circle" :width="30" :percentage="scope.row.percentage"></el-progress>
                </template>
            </el-table-column>
            <el-table-column prop="fileSize" label="文件大小" width="80"> </el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                    <el-button
                        @click="handleReUpload(scope.row)"
                        :disabled="scope.row.reStatus"
                        type="text"
                        size="small"
                        >重传</el-button
                    >
                    <el-button @click="handleAborted(scope.row)" type="text" size="small">取消</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { bindMd5, getUploadUrl, updateFileExtAttr } from 'src/utils/modelUtils';
import { formatSzie, getStorageItem, judgeMultipartUpload, setStorageItem } from 'src/utils/commonUtils';
import RuntimeUtils from 'src/common/js/runtimeUtils';
import busEvent from 'src/utils/busEventUtils';
import axios from 'axios';
import { getFileMd5 } from 'src/utils/calculateUtils';

export default {
    data() {
        return {
            tableData: [],
            uploadPro: [],
            downStatus: false,
            md5: '',
            chunkSize: 1024 * 1024 * 10,
            abortController: new AbortController(),
            md5Config: null,
            needMultipartUpload: false,
        };
    },
    props: {},
    mounted() {},
    computed: {
        uploadFileList() {
            return this.$store.state.storage.uploadFileList;
        },
    },
    watch: {
        uploadFileList: {
            deep: true,
            handler(newVal) {
                if (newVal.length !== 0) {
                    // 原始数组
                    const originLen = this.tableData.length;
                    let tempIndex = 0;
                    newVal.forEach(async (element, index) => {
                        const fileName = element.name.replace(/(.*)\./, '$1_');
                        if (this.findSameFile(fileName) === -1) {
                            if (originLen === 0) {
                                tempIndex = index;
                            } else {
                                tempIndex = index + originLen;
                            }
                            this.tableData.push({
                                id: tempIndex,
                                raw: element.raw,
                                fileName,
                                percentage: 0,
                                reStatus: true,
                                fileSize: formatSzie(element.size),
                            });
                            // 上传时重置分片大小
                            this.chunkSize =  10 * 1024 * 1024;
                            await this.handleUpload(fileName, element.raw, tempIndex);
                        } else {
                            this.$message.error(`${element.name}文件名重复`);
                        }
                    });
                }
            },
        },
    },
    methods: {
        async handleUpload(fileName, file, index) {
            this.abortController = new AbortController();
            this.needMultipartUpload = judgeMultipartUpload(file.size);
            if(this.chunkSize * 1000 < file.size){
              this.chunkSize = Math.ceil(file.size/1000)
            }
            console.log('chunkSize:', this.chunkSize / 1024/ 1024);
            // this.needMultipartUpload = false;

            if (!this.needMultipartUpload) {
                await this.uploadFileController(fileName, file, index);
            } else {
                await this.uploadMultipart(fileName, file, index);
            }
        },
        async handleContinueUpload(fileName, file, index){
          const md5 = this.tableData[index].md5;
          const uploadId = getStorageItem(md5);
          const partETags = [];
          if(uploadId){
            try{
              const uploadedParts = await this.getMultiPart(uploadId);
              let currentChunk = 0;
              for(const item of uploadedParts.parts){
                if(item.partNumber > currentChunk){
                  currentChunk = item.partNumber;
                }
                partETags.push({
                  partETag: item.partETag,
                  partNumber: item.partNumber,
                });
              }
              const chunks = Math.ceil(file.size / this.chunkSize);

              const loadNext = async () => {
                const start = currentChunk * this.chunkSize;
                const end = start + this.chunkSize >= file.size ? file.size : start + this.chunkSize;
                const department = file.slice(start, end);
                const partNumber = currentChunk + 1;
                const uploadPart = await this.putMultipartfile(department, partNumber, uploadId, file.size, index);
                partETags.push({
                  partETag: uploadPart.partETag,
                  partNumber: uploadPart.partNumber,
                });
                currentChunk++;
                if (currentChunk < chunks) {
                  await loadNext();
                } else {
                  const size = await this.completeMultipartUpload(partETags, uploadId, index);
                  if (size === file.size) {
                    const bucketKey = this.$store.state.storage.bucketKey;
                    await this.handleUploadComplete(bucketKey, file, fileName, index);
                    setStorageItem(md5);
                  } else {
                    this.$message.error(`${fileName} 上传过程中数据丢失，上传失败`);
                  }
                }
              };

              await loadNext();
            } catch(e){
              const msg = '文件上传过程中发生错误，上传失败';
              this.$message.error(msg);
              console.log(msg, e);
              setStorageItem(this.tableData[index].md5, uploadId);
              this.tableData[index].reStatus = false;
            }
          } else {
            const msg = 'uploadId不存在，无法上传';
            this.$message.error(msg);
            console.log(msg, e);
          }
        },

        async handleReUpload(row) {
            const rowId = row.id;
            this.abortController = new AbortController();
            this.tableData[row.id].reStatus = true;
            if(this.tableData[rowId].percentage > 0 && this.tableData[rowId].md5){
                await this.handleContinueUpload(this.tableData[rowId].fileName, this.tableData[rowId].raw, rowId);
              } else {
                this.tableData[rowId].md5 = '';
                await this.handleUpload(this.tableData[rowId].fileName, this.tableData[rowId].raw, rowId);
              }
        },
        handleAborted(row) {
          // 手动退出时percentage会重置为0，故障退出时percentage>0
            const rowId = row.id;
            if (!this.tableData[rowId].md5 && this.needMultipartUpload) {
                this.md5Config.cancelToken();
            } else {
                this.abortController.abort();
            }
            this.tableData[rowId].reStatus = false;
            this.tableData[rowId].percentage = 0;
        },
        async uploadFileController(objectKey, file, index) {
            // 上传文件方式1
            const _self = this;
            const params = {
                bucketKey: encodeURIComponent(_self.$store.state.storage.bucketKey),
                objectKey: objectKey,
                type: 7,
                expire: 60000,
            };
            const uploadData = await getUploadUrl(params);
            const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getCloudServiceHostname()}${
                uploadData.data.uploadUrl
            }`;
            // 转二进制出问题
            // axions出问题 todo
            const formData = new FormData();
            formData.append('file', file);
          return new Promise((resolve, reject) => {
            const req = axios({
              method: 'post',
              url,
              data: formData,
              contentType: false,
              processData: false,
              withCredentials: true,
              cache: false,
              dataType: 'json',
              signal: this.abortController.signal,
              headers: {
                'x-bimserver-upload-url': uploadData.data.signature,
              },
              onUploadProgress: (e) => {
                // 处理原生进度事件
                if (_self.tableData[index].percentage !== undefined) {
                  _self.tableData[index].percentage = parseFloat(((e.loaded / e.total) * 100).toFixed(0));
                }
              },
            });
            this.uploadPro[index] = req;
            req.then(() => {
              this.$message.success(`${file.name} 文件上传成功`);
              updateFileExtAttr(params.bucketKey, params.objectKey, file.name);
              busEvent.$emit('refreshList', _self.$store.state.storage.bucketKey);
            }).catch((err) => {
              this.$message.error(`${objectKey} 上传失败`);
              reject(err);
            });
          })

        },
        convertFile(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = function (e) {
                    resolve(e.target.result);
                };
                reader.readAsArrayBuffer(file);
            });
        },
        findSameFile(fileName) {
            let flag = -1;
            this.tableData.forEach((element, index) => {
                if (element.fileName === fileName) {
                    flag = index;
                }
            });
            return flag;
        },
        downUpload() {
            this.downStatus = !this.downStatus;
        },
        closeUpload() {
            // 终止上传任务
            this.uploadPro.forEach((ele) => {
                // ele && ele.abort();
                this.abortController.abort();
            });
            // 清空数据
            this.tableData = [];
            this.uploadPro = [];
            // 关闭上传对话框
            this.$store.commit('SET_FILELIST_STATUS', false);
        },

        async initMultipartUpload(index) {
            const initUrl = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/object/multipart/init`;
            return new Promise((resolve, reject) => {
                const res = axios.post(initUrl, undefined, {
                    headers: {
                        'Content-type': 'application/json',
                    },
                    withCredentials: true,
                    signal: this.abortController.signal,
                });
                this.uploadPro[index] = res;
                res.then((res) => {
                    if (res.status === 200) {
                        resolve(res.data.data.uploadId);
                    }
                }).catch((err) => {
                    reject(err);
                });
            });
        },

        async uploadMultipart(fileName, file, index) {
          let uploadId;
            try {
                this.md5Config = {
                    updatePercentage: (percentage) => {
                        const percentageNum = parseInt(percentage, 10);
                        if (this.tableData[index].percentage !== undefined) {
                            this.tableData[index].percentage = percentageNum < 100 ? percentageNum : 100;
                        }
                    },
                    cancelToken: (c) => {},
                };
                this.tableData[index].md5 = await getFileMd5(file, this.md5Config);
                const fileExist = await this.detectFileExist(this.tableData[index].md5);
                const bucketKey = this.$store.state.storage.bucketKey;

                if (fileExist === 'UPLOAD_NORMAL') {
                uploadId = await this.initMultipartUpload(index);
                if (!uploadId) {
                    return;
                }
                const chunks = Math.ceil(file.size / this.chunkSize);
                const partETags = [];
                let currentChunk = 0;

                const loadNext = async () => {
                    const start = currentChunk * this.chunkSize;
                    const end = start + this.chunkSize >= file.size ? file.size : start + this.chunkSize;
                    const department = file.slice(start, end);
                    const partNumber = currentChunk + 1;
                    const uploadPart = await this.putMultipartfile(department, partNumber, uploadId, file.size, index);
                    partETags.push({
                        partETag: uploadPart.partETag,
                        partNumber: uploadPart.partNumber,
                    });
                    currentChunk++;
                    if (currentChunk < chunks) {
                        await loadNext();
                    } else {
                        const size = await this.completeMultipartUpload(partETags, uploadId, index);
                        if (size === file.size) {
                          this.$message.success(`${fileName} 文件上传成功`);
                          await this.handleUploadComplete(bucketKey, file, fileName, index);
                        } else {
                          this.$message.error(`${fileName} 上传过程中数据丢失，上传失败`);
                        }
                    }
                };

                await loadNext();
                } else {
                  this.$message.success(`${fileName} 文件上传成功`);
                  await this.handleUploadComplete(bucketKey, file, fileName, index);
                }
            } catch (e) {
                const msg = '文件上传过程中发生错误，上传失败';
                this.$message.error(msg);
                console.log(msg, e);
                setStorageItem(this.tableData[index].md5, uploadId);
                this.tableData[index].reStatus = false;
            }
        },

        async putMultipartfile(content, partNumber, uploadId, totalSize, index) {
            const formData = new FormData();
            formData.append('partFile', content);
            const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/object/multipart/upload?uploadId=${uploadId}&partNumber=${partNumber}`;
            return new Promise((resolve, reject) => {
                const res = axios({
                    method: 'post',
                    url,
                    data: formData,
                    contentType: false,
                    processData: false,
                    withCredentials: true,
                    signal: this.abortController.signal,
                    onUploadProgress: (e) => {
                        // 处理原生进度事件
                        if (this.tableData[index].percentage !== undefined) {
                            const percentage = ((e.loaded + this.chunkSize * (partNumber - 1)) / totalSize) * 100;
                            this.tableData[index].percentage =
                                percentage < 100 ? parseFloat(percentage.toFixed(0)) : 100;
                        }
                    },
                });
                this.uploadPro[index] = res;
                res.then((res) => {
                    resolve(res.data.data);
                }).catch((err) => {
                    reject(err);
                });
            });
        },

        async completeMultipartUpload(partETags, uploadId, index) {
            const data = {
                md5: this.tableData[index].md5,
                partETags,
                uploadId,
            };
            const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/object/multipart/complete`;
            return new Promise((resolve, reject) => {
                const res = axios.post(url, data, {
                    headers: {
                        'Content-type': 'application/json',
                    },
                    withCredentials: true,
                    signal: this.abortController.signal,
                });
                this.uploadPro[index] = res;
                res.then((res) => {
                    resolve(res.data.data.size);
                }).catch((err) => {
                    reject(err);
                });
            });
        },

        async handleUploadComplete(bucketKey, file, fileName, index) {
            const params = {
                bucketKey: encodeURIComponent(bucketKey),
                objectKey: fileName,
                type: 7,
                expire: 60000,
            };
            const urlData = await getUploadUrl(params);
            const data = {
                uploadUrl: urlData.data.uploadUrl,
                signature: urlData.data.signature,
                md5: this.tableData[index].md5,
            };
            const md5res = await bindMd5(data);
            await updateFileExtAttr(params.bucketKey, params.objectKey, file.name);
            busEvent.$emit('refreshList', bucketKey);
        },

        async detectFileExist(md5) {
            const data = {
                md5: md5,
            };
            const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/file/detectFileExists`;
            return new Promise((resolve, reject) => {
                axios
                    .post(url, data, {
                        headers: {
                            'Content-type': 'application/json',
                        },
                        withCredentials: true,
                    })
                    .then((res) => {
                        resolve(res.data.data.status);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        async getMultiPart(uploadId){
          const url = `${RuntimeUtils.instance.getObvServiceProtocol()}//${RuntimeUtils.instance.getConsoleServiceHostname()}/bimserver/console/v3/object/multipart/parts?uploadId=${uploadId}`;
          return new Promise((resolve, reject) => {
            axios
              .get(url, {
                headers: {
                  'Content-type': 'application/json',
                },
                withCredentials: true,
              })
              .then((res) => {
                resolve(res.data.data);
              })
              .catch((err) => {
                reject(err);
              });
          });
        }
    },
};
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
@import '~common/stylus/variable'
.upload-file-status >>> .el-progress__text
  width 110%
.upload-file-status.isDown
  transform translateY(202px)
.upload-file-status.notDown
  height 252px
.upload-file-status
  width 550px
  position fixed
  z-index 2020
  background white
  bottom 0px
  right 7px
  transition all 1s ease
  .upload-btn-group
    position absolute
    right 0px
    top 13px
    font-size 18px
    z-index 9
    color $font-console
    .upload-arrow
      margin-right 5px
      cursor pointer
      &:hover
        color $font-title
    .upload-close
      margin-right 5px
      cursor pointer
      &:hover
        color $font-title
</style>



// WEBPACK FOOTER //
// src/pages/devCenter/consoleLab/components/upload-file-status.vue